import React from 'react';
import './NavHeader.sass';

export const ProgressBar = ({currentStepId, totalSteps}) => {
  const value = (currentStepId / totalSteps) * 100;
  return (
    <progress
      className="fabric-header__progress-bar"
      max="100"
      value={Number.isNaN(value) ? 0 : value}
    />
  );
};
